import { QUERY_RESULT_CACHE_KEY } from '../Containers/Docs/constants';
import { IQueryResponse } from '../Types/Docs';

export interface IQueryResultCache {
  query: string;
  topK: number;
  result: IQueryResponse;
  cachedAt: string;
}

export const saveQueryResultCache = (cache: Omit<IQueryResultCache, 'cachedAt'>): void => {
  try {
    const entry: IQueryResultCache = {
      ...cache,
      cachedAt: new Date().toISOString(),
    };
    sessionStorage.setItem(QUERY_RESULT_CACHE_KEY, JSON.stringify(entry));
  } catch {
    // Ignore quota or private-mode errors
  }
};

export const getQueryResultCache = (): IQueryResultCache | null => {
  try {
    const stored = sessionStorage.getItem(QUERY_RESULT_CACHE_KEY);
    if (!stored) return null;
    return JSON.parse(stored) as IQueryResultCache;
  } catch {
    return null;
  }
};

export const clearQueryResultCache = (): void => {
  try {
    sessionStorage.removeItem(QUERY_RESULT_CACHE_KEY);
  } catch {
    // Ignore storage errors
  }
};
